import { ENDPOINTS, type ApiResponseTypeV3 } from '@/api'
import { ApiClient } from '@/utils'
import { useQuery } from '@tanstack/vue-query'
import { useAuthStore } from '@/stores/auth'
import { getSecureCookie } from '@/utils/cookie-utils'
import { COOKIE_KEYS } from '@/constants'

export const getUserPlan = async () => {
  const authStore = useAuthStore()
  const sessionToken = getSecureCookie(COOKIE_KEYS.userToken)
  const response = await ApiClient.get<ApiResponseTypeV3<UserPlanResponseType>>(
    ENDPOINTS.Profile.UserPlan
  )

  // A response from a previous login must not update the current account.
  if (
    authStore.isAuthenticated &&
    sessionToken === getSecureCookie(COOKIE_KEYS.userToken)
  ) {
    const plan = response.data
    authStore.setHasAccess(
      Boolean(
        plan &&
          plan.priority > 0 &&
          (plan.isLifeTime || new Date(plan.expiredAt).getTime() > Date.now())
      )
    )
  }

  return response
}

export const useGetCurrentPlanQuery = () =>
  useQuery({
    queryFn: () => getUserPlan(),
    queryKey: ['profile', 'user_plan'],
    staleTime: 0
  })

export interface UserPlanResponseType {
  id: string
  slug: string
  productId: any
  title: string
  hint: string
  description: string
  duration: number
  type: number
  icon: string
  banner: string
  isLifeTime: boolean
  color: string
  expiredAt: any
  priority: number
  pricing: Pricing
  accessList: AccessList[]
  subscription?: { type: string }
}

export interface Pricing {
  id: string
  price: number
  oldPrice: any
  offExpiredAt: any
  unit: string
  unitId: number
  unitSign: string
  unitSlug: string
}

export interface AccessList {
  id: string
  title: string
  description: string
  image: string
  slug: string
}

export interface Message {
  id: string
  content: string
}
